import { render } from "./OrgList.vue?vue&type=template&id=335b6295"
import script from "./OrgList.vue?vue&type=script&lang=js"
export * from "./OrgList.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src834291806/src/oms-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__